/** CONSTANTS */

export const CONTENT_DELIVERY_API_URL = '/api/ab/v3/content';
